export const environment = {
  production: false,
  type: 'DEV',
  webApiUrl: "https://fw4v1qhxl3.execute-api.us-east-1.amazonaws.com/develop",
  keyGoogle: 'AIzaSyBMD4x5lTW_cVtSt3cKBVYu1qqXq12ryNY',
  recaptcha: {
    siteKey: '6LcW31MqAAAAAAcVGQCU4JKd3NBckNh1kQxSWcS1',
  },
  features: {
    enableEmailOtp: true,
    enablePhoneOtp: true,
    enableBioDocumentValidation: true,
  },
  otp: {
    expirationMinutes: 10,
    resendCooldownSeconds: 120,
    maxAttempts: 3,
  },
  bio: {
    baseUrl: 'https://fw4v1qhxl3.execute-api.us-east-1.amazonaws.com/develop',
    countryId: 'AR',
  },
};
